export default __webpack_public_path__ + "static/media/premiumTick.4e50a7e5.svg";